export const PIPELINE_ORDER = ["SOURCING", "CONTACT", "SCHEDULED", "INSPECTION", "PURCHASE", "DELIVERED", "DISCARDED"] as const;
export type PipelineStage = (typeof PIPELINE_ORDER)[number];

export const PIPELINE_LABELS: Record<PipelineStage, string> = {
  SOURCING: "Búsqueda",
  CONTACT: "Contacto",
  SCHEDULED: "Visita agendada",
  INSPECTION: "Inspección",
  PURCHASE: "Compra y trámite",
  DELIVERED: "Entregado",
  DISCARDED: "Descartado",
};

/** Accent bar colour per column. */
export const PIPELINE_ACCENT: Record<PipelineStage, string> = {
  SOURCING: "#6a7282",
  CONTACT: "#2f6fed",
  SCHEDULED: "#7c3aed",
  INSPECTION: "#b45309",
  PURCHASE: "#0e7490",
  DELIVERED: "#15803d",
  DISCARDED: "#b91c1c",
};
